import {
  Collapse as AntdCollapse,
  CollapseProps as AntdCollapseProps,
} from "antd";
import { CMP_PREFIX } from "@/base/constant";

export interface CollapseProps extends AntdCollapseProps {}

export const collapsePrefixCls = `${CMP_PREFIX}-collapse`;

export const Collapse = ({
  expandIconPosition = "end",
  ...props
}: CollapseProps) => {
  return <AntdCollapse expandIconPosition={expandIconPosition} {...props} />;
};
